module.exports = __webpack_public_path__ + "static/media/photo.9aae9073.png";